import styled, { css } from 'styled-components/macro';
import { body18, h2, h4, h6, body12, body16 } from '../../../../utils/css/typography';
import { colorPink, colorYellow, colorBlue, colorDarkGrey, colorWhite, colorRed } from '../../../../utils/css/colors';
import { FieldTitle } from '../../../common/FormFieldContainer/FormFieldContainerStyle';
import { Link } from 'react-router-dom';
import { mediumFont } from '../../../../utils/css/fonts';
import { mobile } from '../../../../utils/css/media';
import ButtonSmall from '../../../common/ButtonSmall';

export interface SlashSeparatorSpan {
	fontWeight?: string;
}

export const FieldContainer = styled.div<{
	fullWidthField?: boolean;
	isFlexBasis?: string;
	widthOfField?: string;
	marginInlineStart?: string;
	fontWeight?: string;
}>`
	display: flex;
	align-items: baseline;
	width: ${({ fullWidthField }) => fullWidthField && '100%'};
	max-width: ${props => (props.widthOfField ? props.widthOfField : '')};
	flex-basis: ${props => (props.isFlexBasis ? props.isFlexBasis : 'unset')};
	padding: 1rem 0;
	margin-inline-start: ${({ marginInlineStart }) => (marginInlineStart ? marginInlineStart : 'unset')};
	& > div {
		width: ${({ fullWidthField }) => fullWidthField && '100%'};
	}
`;

// @ts-ignore
export const SpaceBetweenFieldContainer = styled(FieldContainer)`
	justify-content: space-between;
	padding: 0.5rem 1rem;
`;

export const SpacedFieldConteiner = styled.div`
	display: flex;
	align-items: center;
	margin-inline-end: 7rem;
`;

export const ColoredFieldTitle = styled(FieldTitle)`
	color: ${colorPink};
`;

export const ColoredText = styled.div`
	color: ${colorPink};
	font-weight: bold;
`;

export const LinkText = styled(Link)`
	color: ${colorBlue};
	font-weight: bold;
	padding: 0 0.5rem;
`;

export const UnderlineFieldTitle = styled(FieldTitle)`
	text-decoration: underline;
`;

export const PaddingDiv = styled.div`
	padding: 1rem;
`;

export const SeparationLine = styled.div`
	width: 100%;
	border: 0.7px solid ${colorDarkGrey};
	margin: 0 auto;
	opacity: 0.5;
	transform: rotate(0.17deg);
	margin: 1.5rem 0;
`;

export const HeaderWithButton = styled.div`
	display: flex;
	justify-content: space-between;
	width: 100%;
	align-items: center;
	padding: 0 1rem;
`;

export const CircleButton = styled.button<{ size: number }>`
	width: ${({ size }) => `${size}px`};
	height: ${({ size }) => `${size}px`};
	font-family: ${mediumFont};
	background-color: ${colorYellow};
	border-radius: 50%;
	display: flex;
	justify-content: center;
	align-items: center;
	box-shadow: 1px 2px 2px rgba(0, 0, 0, 0.25);
	margin: 0 0.5rem;
	cursor: pointer;
	border: none;
	outline: none;
	${body16}
	font-weight: bold;
	&:disabled {
		opacity: 0.38;
		pointer-events: none;
	}
`;

export const WitnessProfileFlex = styled.div`
	display: flex;
	margin: 63px 0 112px 0;
	flex-wrap: wrap;
	justify-content: space-between;
`;

export const AlignCenterButtonDiv = styled.div`
	display: flex;
	justify-content: center;
	margin-bottom: 93px;
`;

export const SecondRowFlex = styled.div`
	flex: 5;
	margin-inline-start: 5rem;

	@media only screen and (max-width: 982px) {
		margin-inline-start: 0;
	}

	${mobile(css`
		margin: 5px;
	`)};
`;

export const WitnessFirstRow = styled.div`
	flex: 6;

	${mobile(css`
		margin: 5px;
	`)};
`;

export const SlashSeparatorSpan = styled.span<{ fontWeight?: string }>`
	font-weight: ${({ fontWeight }) => (fontWeight ? fontWeight : 'bold')};

	&::after {
		content: ' / ';
		padding: 0 0.2rem;
	}
	&:last-child {
		content: '';

		&::after {
			content: '';
		}
	}

	&:first-child {
		content: '';
	}
`;

export const WitnessProfileName = styled.h2`
	${h2};
`;

export const WitnessProfileTitle = styled.h3`
	${h4}
`;

export const FlexDivCenter = styled.div`
	display: flex;
	justify-content: center;
`;

export const BackArrowSpan = styled.span`
	${body18};
	font-weight: 500;
	line-height: 125.26%;
	margin-bottom: 14px;
`;

export const ArrowFlexDiv = styled.div`
	display: flex;
	margin-bottom: 12px;
	cursor: pointer;
`;

export const ImgSize = styled.img<{ direction: string }>`
	width: 18px;
	height: 15px;
	margin-inline-end: 5px;
	transform: ${({ direction }) => (direction === 'en' ? 'scaleX(-1)' : '')};
`;

export const YearTabs = styled.div`
	display: flex;
	justify-content: center;
	cursor: pointer;
	${h6}
	margin: 17px 0 40px 0;
`;

export const YearTabsSpan = styled.button<{ isActive?: boolean }>`
	margin: 0 22px;
	text-transform: uppercase;
	background: none;
	padding: 4px;
	display: inline-block;
	border: none;
	${h6}
	cursor: pointer;

	text-decoration: none;
	color: ${props => (props.isActive ? colorPink : 'unset')};

	border-bottom: ${props => (props.isActive ? `1px solid ${colorPink}` : '')};
	&:hover {
		border-bottom: 1px solid ${colorPink};
		color: ${colorPink};
	}
	&:focus {
		outline: 0;
	}
`;

export const PersonalDetailsInput = styled.div`
	width: 85%;
	height: 52px;
`;

export const WitnessStatusEditContainer = styled.div`
	display: flex;
	align-items: baseline;
	flex-wrap: wrap;
	justify-content: space-between;
	margin-bottom: 0.8rem;
`;

export const PlaceholderDiv = styled.div`
	width: 100%;
	height: 100%;
	background-color: ${colorWhite};
	border: 1px solid #646464;
	border-radius: 6px;
	padding: 8px;
`;

export const ButtonContainer = styled.div`
	display: flex;
	align-items: flex-end;
	justify-content: flex-end;
	padding-inline-start: 1rem;

	${mobile(css`
		margin-top: 18px;
	`)};
`;

export const FlexInputContainer = styled.div`
	height: 69px;
	position: relative;
	min-width: 80%;
`;

export const FlexDivComment = styled.div`
	display: flex;
	margin: 19px 0 38px 0;
	justify-content: space-between;
	align-items: stretch;
	position: relative;

	${mobile(css`
		flex-direction: column;
	`)};
`;

export const FlexDivFluid = styled.div<{ padding?: string }>`
	width: 98%;
	display: flex;
	padding: ${props => (props.padding ? props.padding : 'unset')};
	align-items: baseline;
	justify-content: space-between;
	position: relative;
`;

export const LimitMaxString = styled.div<{ isLeftOrRight?: string }>`
	position: absolute;
	bottom: 0;
	left: ${({ isLeftOrRight }) => (isLeftOrRight === 'rtl' ? '20px' : '')};
	${body12}
	right: ${({ isLeftOrRight }) => (isLeftOrRight === 'ltr' ? '20px' : '')};
`;

export const FlexDivRealative = styled.div`
	position: relative;
	width: 89%;
	display: flex;
`;

export const AvilabilityError = styled.div`
	color: ${colorRed};
	padding-inline-start: 1rem;
	${body12};
`;

export const TextareaContainer = styled.div`
	position: relative;
	width: 77.5%;
	${mobile(css`
		width: 100%;
		margin-bottom: 5%;
	`)};
`;

export const DeleteCanButton = styled.img<{ isEditMode: boolean }>`
	opacity: ${({ isEditMode }) => (isEditMode ? '1' : '0.5')};
	outline: none;
	cursor: ${({ isEditMode }) => (isEditMode ? 'pointer' : '')};
	border: none;
	background: none;
`;

export const DeleteButton = styled(ButtonSmall)`
	padding: 12px;
	width: 13%;

	${mobile(css`
		width: 33%;
	`)};
`;
